module.exports = __webpack_public_path__ + "static/media/Banner 01 (002).78375bc7.jpg";